import PreloaderGIF from './images/pre-loader.gif';

export const Preloader = () => {
    return (
      <div className="section-title">
        <p className="paragraph">Loading...</p>
        <img src={PreloaderGIF} alt="SVG Image" width="120" height="120" style={{ fill: "red" }} />
      </div>
    );
  };